import { AgentActivity } from '@numeo/types'
import axios from 'axios'

export interface AgentActivityFilters {
    projectId: string
    entityId?: string
    entityType?: string
    agentType?: string
    action?: string
    limit?: number
    before?: string
}

export const getAgentActivities = async (filters: AgentActivityFilters): Promise<AgentActivity[]> => {
    try {
        const queryParams = new URLSearchParams()
        if (filters.projectId) queryParams.append('projectId', filters.projectId)
        if (filters.entityId) queryParams.append('entityId', filters.entityId)
        if (filters.entityType) queryParams.append('entityType', filters.entityType)
        if (filters.agentType) queryParams.append('agentType', filters.agentType)
        if (filters.action) queryParams.append('action', filters.action)
        if (filters.limit) queryParams.append('limit', filters.limit.toString())
        if (filters.before) queryParams.append('before', filters.before)

        const response = await axios.get(`/updater/agent-activities?${queryParams.toString()}`)
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching agent activities:', error)
        return []
    }
}

const agentActivitiesApi = {
    getAgentActivities,
}

export default agentActivitiesApi
